import React from 'react';
import ReactMarkdown from 'react-markdown';

export const MarkdownDisplay = ({text, plugins, remarkPlugins = []}) => {

    return (
        <ReactMarkdown rehypePlugins={plugins} remarkPlugins={remarkPlugins}>{text}</ReactMarkdown>
    )
}
